import { IPolicyRoles } from 'shared';
import { UserRole } from 'shared';
import { Policy } from 'shared';

export const AppPolicyRoles: IPolicyRoles[] = [
    {
        policy: Policy.ApproveMarkupCheckout,
        roles: [UserRole.ProviderShopUser],
    },
    {
        policy: Policy.EditSuppliers,
        roles: [UserRole.Administrator, UserRole.Supporter],
    },
    {
        policy: Policy.ResetSupplierAccounts,
        roles: [UserRole.Administrator],
    },
    {
        policy: Policy.AccessUserManager,
        roles: [UserRole.ProviderAdmin, UserRole.AreaManager],
    },
    {
        policy: Policy.ManageUsers,
        roles: [UserRole.ProviderAdmin],
    },
    {
        policy: Policy.AccessOrderReturn,
        roles: [UserRole.ProviderShopUser, UserRole.ProviderAdmin],
    },
    {
        policy: Policy.StartOrderReturn,
        roles: [UserRole.ProviderShopUser],
    },
    {
        policy: Policy.ApproveOrderReturn,
        roles: [UserRole.ProviderAdmin],
    },
    {
        policy: Policy.AccessProductManager,
        roles: [UserRole.Administrator],
    },
    {
        policy: Policy.InspectMarkupOrder,
        roles: [UserRole.ProviderShopUser],
    },
    {
        policy: Policy.AccessTranslations,
        roles: [UserRole.Translator, UserRole.Administrator],
    },
];
